import type {
  TimeseriesInteractionState,
  TimeseriesSelectState,
} from '../types/state.js';

export function reduceExploreTimeseriesSelect<
  T extends TimeseriesInteractionState,
>(select: Partial<TimeseriesSelectState>) {
  return (prev: T): T => ({
    ...prev,
    select: {
      ...prev.select,
      ...select,
    },
    explore: {
      visible: false,
      pinned: false,
    },
    highlightedSeriesIds: undefined,
  });
}
